import { MobileIcon, StudioPlatformIcon, WebPlatformIcon } from "icons";
import { CoachIcon } from "pages/tonal-visualize/iconComponents/CoachIcon";
import { StrikerIcon } from "pages/tonal-visualize/iconComponents/strikerIcon";

export const platformItems = [
  {
    title: "Mobile Application",
    key: "mobileApplication",
    isActive: true,
    Icon: MobileIcon,
    borderColor: "#006AB3",
  },
  {
    title: "Web Application",
    key: "webApplication",
    isActive: false,
    Icon: WebPlatformIcon,
    borderColor: "#F4BD00",
  },
  {
    title: "Studio Application",
    key: "studioApplication",
    isActive: false,
    Icon: StudioPlatformIcon,
    borderColor: "#78ba2c",
  },
];
export const studioObj = {
  title: "Studio",
  icon: StudioPlatformIcon,
  bgColor: "#FFFAED",
};
export const webObj = {
  title: "Web",
  icon: WebPlatformIcon,
  bgColor: "#E7FFC5",
};
export const mobileObj = {
  title: "Mobile",
  icon: MobileIcon,
  bgColor: "#EDFDFF",
};

export const avaialbleData = {
  trial: {
    months: "4 Weeks",
    platforms: [mobileObj],
    id: 1,
  },
  basic: {
    months: "3 Months",
    platforms: [mobileObj],
    id: 2,
  },
  standard: {
    months: "6 Months",
    platforms: [webObj, mobileObj],
    id: 3,
  },
  premium: {
    months: "12 Months",
    platforms: [studioObj, webObj, mobileObj],
    id: 4,
  },
};

export const roleOptions = [
  {
    label: "Striker",
    icon: StrikerIcon,
    id: 5,
  },
  {
    label: "Coach",
    icon: CoachIcon,
    id: 4,
  },
];
export const PLAN_KEYS = {
  TRIAL: "trial",
  BASIC: "basic",
  STANDARD: "standard",
  PREMIUM: "premium",
};

export const planTypes = [
  {
    title: "Trial (2 Weeks)",
    key: PLAN_KEYS.TRIAL,
    id: 1,
    platforms: [mobileObj],
  },
  {
    title: "Basic",
    key: PLAN_KEYS.BASIC,
    id: 2,
    platforms: [mobileObj],
  },
  {
    title: "Standard",
    key: PLAN_KEYS.STANDARD,
    id: 3,
    platforms: [webObj, mobileObj],
  },
  {
    title: "Premium",
    key: PLAN_KEYS.PREMIUM,
    id: 4,
    platforms: [studioObj, webObj, mobileObj],
  },
];
export const planOptions = ["Pakistan", "Bangladesh", "China"];
export const cityOptions = ["Lahore", "Islamabad", "Multan"];
export const weightOptions = ["kg", "lb"];
export const heightOptions = ["cm", "inch"];
export const countryCodes = ["+1", "+92"];
export const languageOptions = ["English", "Korean"];
export const genderOptions = [
  { key: "1", label: "Male" },
  { key: "2", label: "Female" },
];
export const handednessOptions = [
  { key: "1", label: "Left Handed" },
  { key: "2", label: "Right Handed" },
];
export const planDuration = [
  {
    title: "1 Month",
    key: "1 Month",
    months: 1,
  },
  {
    title: "3 Months",
    key: "3 Months",
    months: 3,
  },
  {
    title: "6 Months",
    key: "6 Months",
    months: 6,
  },
  {
    title: "12 Months",
    key: "12 Months",
    months: 12,
  },
];
export const formInitialData = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  genderId: 1,
  genderName: "Male",
  role: 5,
  postCode: "",
  city: "",
  contactNumer: "",
  contactNumberCountryId: "",
  picture: "",
  password: "",
  playerType: "2",
  playerTypeLabel: "Right Handed",
  languageId: "6",
  language: "English",
  countryId: "",
  email: "",
  height: "",
  heightUnit: "cm",
  weight: "",
  weightUnit: "lb",
  countryImage: "",
  duration: {},
  plan: planTypes[0],
};

export const languages = [
  { id: 1, name: "Chinese" },
  { id: 2, name: "Japanese" },
  { id: 3, name: "German" },
  { id: 4, name: "French" },
  { id: 5, name: "Spanish" },
  { id: 6, name: "English" },
  { id: 7, name: "Mandarin" },
  { id: 8, name: "Korean" },
];
